import { useTimeZoneQuery, TimeZoneInput } from '@portal/schema';

export const useTimeZone = (input: TimeZoneInput): string | undefined => {
  const { data } = useTimeZoneQuery({ variables: { input } });
  return data?.timeZone;
};
